// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2dCGw","head":"ProcedureTableInfo_head__22UCi"};